module.exports = __webpack_public_path__ + "img/4-bottom.a4d3633a.png";